"use strict";
const _ = require('lodash');
const isWhitelabel = shopConfig => {
    const subdomain = _.get(shopConfig, 'subdomain');
    if (!subdomain)
        return false;
    return !_.includes(['flaivy', 'dev2', 'demo-privab-shop'], subdomain);
};
const isFlaivyShop = ctxOrShopConfig => {
    let value;
    if (_.get(ctxOrShopConfig, 'meta.subdomain')) {
        value = _.get(ctxOrShopConfig, 'meta.subdomain');
    }
    if (_.get(ctxOrShopConfig, 'subdomain')) {
        value = _.get(ctxOrShopConfig, 'subdomain');
    }
    return value === 'flaivy' || value === 'dev2';
};
const isPrivabShop = shopConfig => shopConfig && shopConfig.theme === 'privabTheme';
const isPro = ctxOrShopConfig => {
    let value;
    if (_.get(ctxOrShopConfig, 'meta.subdomain')) {
        value = _.get(ctxOrShopConfig, 'meta.subdomain');
    }
    if (_.get(ctxOrShopConfig, 'subdomain')) {
        value = _.get(ctxOrShopConfig, 'subdomain');
    }
    return value === 'pro' || value === 'dev-pro' || value === 'light';
};
// IMPORTANT - a user needs a shopConfigId and owningSupplierOrganizationId to access a shop that uses supplierCustomers
const getUserWhere = (shopConfig, email) => {
    const emailToLowerCase = email.toLowerCase();
    const usesSupplierCustomer = _.get(shopConfig, 'usesSupplierCustomer');
    const shopConfigId = _.get(shopConfig, 'id', 'non-existent-shop-config-id');
    const owningSupplierOrganizationId = _.get(shopConfig, 'organization.id');
    return usesSupplierCustomer
        ? {
            where: {
                email: emailToLowerCase,
                shopConfigId,
                owningSupplierOrganizationId,
            },
        }
        : {
            // do we need to check organization here too?
            where: { email: emailToLowerCase, owningSupplierOrganizationId: null },
        };
};
const shopInviteMailBody = (shopConfig, invite) => {
    const baseUrl = _.get(shopConfig, 'baseUrl', 'flaivy.com');
    const inviteUrl = `https://${baseUrl}/invite/${invite.id}?email=${invite.email}`;
    return `# Välkommen till ${shopConfig.companyName}!

  ${invite.message}

  [Länk till inbjudan](${inviteUrl})`;
};
const getNavbarHeight = shopConfig => {
    if (isFlaivyShop(shopConfig)) {
        return 160;
    }
    return 120;
};
module.exports = {
    shopInviteMailBody,
    isWhitelabel,
    isFlaivyShop,
    isPrivabShop,
    getUserWhere,
    isPro,
    getNavbarHeight,
};
